import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import constants from 'utils/constants'
export default function JoinedMatchingRoomList({roomList}) {
  return (
    <RoomList>
      {roomList.map((room)=>{
        let ownerProfile = (room?.owner?.profile_img) ? `${constants['imagePath']}/user_profile_img/${room.owner.profile_img}`:null;
        return(
            <RoomItemLink key={`joined-matching-room-${room['room_no']}`} to={`/matching/room/${room['room_no']}`}>
              <RoomItem>
                <ProfileImgWrapper>
                  <ProfileImg  src={ownerProfile}/>
                </ProfileImgWrapper>
                <RoomTitleWrapper>
                  <RoomTitleTxt>{room['title']}</RoomTitleTxt>
                </RoomTitleWrapper>
              </RoomItem>
            </RoomItemLink>
        )
      })}
    </RoomList>
  );
}
const RoomList = styled.div`
  white-space: nowrap;
  overflow-x: scroll;
`

const RoomItemLink = styled(Link)`
  margin-right: calc(100vw*(17/375));
  display: inline-block;
  text-align:center;
`
const RoomItem = styled.div`
  display: inline-block;  
`;
const ProfileImgWrapper = styled.div`
  width: calc(100vw*(45/375));
  height: calc(100vw*(45/375));
  overflow: hidden;
  border-radius: 100%;
  margin : 0 auto;
`;
const ProfileImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit:cover;
`;
const RoomTitleWrapper = styled.div`
  max-width:calc(100vw*(65/375));
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const RoomTitleTxt = styled.span`
  font-weight: 500;
  font-size: calc(100vw*(12/375));
  line-height: calc(100vw*(17/375));
  color: #4E4E4E;
`;